import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-opening-hours',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './opening-hours.component.html',
  styleUrls: ['./opening-hours.component.scss'],
})
export class OpeningHoursLibComponent {
  isDealerOpeningHoursValid = input.required<boolean>();
  isDealerOpeningWeekend = input.required<boolean>();
  minHour = input<string>();
  maxHour = input<string>();
  maxHourWeekend = input<string>();
  minHourWeekend = input<string>();
}
